import { BillReceiversType } from "../../../../modules/company/admin/accounting/bill-receivers/billReceiversTypes"
import { Organizer } from "../../../types/OrganizerTypes"
import { CreditNoteType } from "../creditNoteDialog/helpers"
import { BuyerParty } from "../../../../modules/payments/orderTypes"
import { PaymentMethodOptionValue } from "../../createOrder/components/form/formTypes"
import { BillReceiversItemContactDetails, EndpointEan, EndpointEmail } from "../../createOrder/createOrderTypes"

export enum AccountingReferenceType {
    ORIGINAL_ORDER = "ORIGINAL_ORDER",
}
type AccountingReference = Readonly<{
    referenceType: AccountingReferenceType
    orderId: number
}>
type Payment = Readonly<{
    buyerCustomerParty?: {
        id: number
    }
    method: PaymentMethodOptionValue | string
    type?: CreditNoteType
    accounting?: {
        references?: AccountingReference[]
        dimensions: AccountingDimension[]
    }
}>

type AccountingDimension = Readonly<{
    id: number
}>

export enum DeliveryLocationType {
    RESOURCE = "RESOURCE",
    OTHER_LOCATION = "OTHER_LOCATION",
}

export type DeliveryLocationInfo =
    | Readonly<{
          type: DeliveryLocationType.RESOURCE
          resourceId: number
      }>
    | Readonly<{
          type: DeliveryLocationType.OTHER_LOCATION
          name: string
      }>

export type MeetingServiceOrderDetailsDelivery = Readonly<{
    deliveryLocation?: DeliveryLocationInfo
    deliveryTime: string //  "2020-08-20T10:00"
    orderLines: OrderLine[]
    type: "DELIVERY" | string
    seats: number
    satellite?: { id: number }
}>

type OrderLine = Readonly<{
    productId?: number
    items: number
    buyerParty: BuyerParty
    priceListId?: number
}>

type MeetingDetails = Readonly<{
    meetingName: string
    startDateTime?: string // ISO DateTime e.g. "2021-02-10 12:30:00"
    endDateTime?: string
    attendees: Attendee[]
    organizers: Organizer[]
    recurrence?: {
        pattern: string
    }
}>
export type Attendee = Readonly<{
    company: string
    name: string
    isExternal: boolean
}>

export type MeetingServiceOrderDetails = Readonly<{
    order?: { id: number }
    merchant: { id: number }
    priceList: { id: number }
    webshop: { id: number }
    payment: Payment
    deliveries: MeetingServiceOrderDetailsDelivery[]
    meetingDetails: MeetingDetails
    orderNote: string
    orderType: "MEETING_SERVICE" | string
}>

// Bill Receiver

export type BillReceiver = Readonly<{
    id: number
    type: BillReceiversType
    name: string
    vatnumber?: string
    address?: {
        displayName: string
        country?: { countryCode: string; name: string }
        postalCode?: string
        city?: string
        addressLines?: string[]
    }
    endpoint?: EndpointEan | EndpointEmail
    isActive?: boolean
    contactDetails?: BillReceiversItemContactDetails
}>
